export default __webpack_public_path__ + "static/media/Spinner_US.660a324a.svg";